export default "__VITE_ASSET__DitkR61T__"